import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class MonitoringPackageAddressEntity {
  source?: LngLatEntity
  sourceAddressName?: string | null
  destination?: LngLatEntity
  destinationAddressName?: string | null
}
